export default "__VITE_PUBLIC_ASSET__8ec0339c__"